import { createContext, useContext } from 'react'

//
// "Has the dialog around me finished opening?"
//
// Its own module rather than a export from ModalDialog, because Table has to ask
// the question and ModalDialog uses Button from Controls, which is where Table
// lives — importing one from the other closes a circle.
//
// ⚠️ Why anything asks at all: an rsuite Table measures itself as soon as it is
// mounted. Inside a dialog that is still animating open, the box it measures
// keeps changing — and under WebKit that measurement never settles. It measures,
// sets state, measures again, and React gives up with "Maximum update depth
// exceeded". The dialog is dead before anything is loaded, which is why no
// request was ever sent.
//
// Measured on 2026-09-06 against a standalone page with no application code:
// every rsuite Table inside an rsuite Modal, in WebKit. Not caused by our column
// setup — it happens without wordWrap too — and not fixed by rsuite 6.2.4, nor
// by height, autoHeight, virtualized or shouldUpdateScroll. Mounting the table
// after the dialog has settled is what fixes it. Chromium and Gecko are fine
// either way; on iOS every browser is WebKit, so this is not a Safari niche.
//
// Default true: outside a dialog there is nothing to wait for, and a component
// that never hears otherwise must not sit and wait forever.
//
export const ModalReadyContext = createContext<boolean>(true)

export const useModalReady = () => useContext(ModalReadyContext)
